import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { X } from 'react-feather';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Input from '../components/Input';
import Select from '../components/Select'
import Button from '../components/Button';
import Footer from '../components/Footer';

import './Home.css'

function Home() {
    const error = (msg) => toast.error(msg, { autoClose: 3000 });

    const [isOpen, setIsOpen] = useState(false);

    const [isValidatingLogin, setIsValidatingLogin] = useState(false)

    const [emailLogin, setEmailLogin] = useState('');
    const [passwordLogin, setPasswordLogin] = useState('');
    const history = useHistory()

    function show() {
        return isOpen ? 'block' : 'none'
    }

    async function signin(e) {
        e.preventDefault()

        const data = { email: emailLogin, password: passwordLogin }

        if (data.email === '' || data.password === '') {
            error("Usuário e/ou senha inválidos")
            return false;
        }

        setIsValidatingLogin(true)

        setTimeout(() => {
            history.push("/timeline")
            setIsValidatingLogin(false)
        }, 2000);
    }

    toast.configure()

    return (
        <>

            <div className="modal-signup" style={{ display: show() }}>
                <button className="btn-close">
                    <X height="30" width="30" onClick={() => setIsOpen(false)} />
                </button>
                <div className="modal-signup-content">
                    <h1>Rede Social</h1>
                    <form>
                        <Input type="email" placeholder="Email" />
                        <Input type="text" placeholder="Nome" />
                        <div className="date">
                            <Input type="text" placeholder="Dia" />
                            <Input type="text" placeholder="Mês" />
                            <Input type="text" placeholder="Ano" />
                        </div>
                        <Select />
                        <Input type="password" placeholder="Senha" />
                        <Button text={"Cadastrar"} type="submit" />
                    </form>
                </div>
            </div>

            <div className="home-background">
                <div className="home-content">
                    <div className="content-main">
                        <div className="content-area">
                            <div className="content">
                                <h1>Rede Social</h1>
                                <form onSubmit={signin}>
                                    <Input placeholder="E-mail" type="email" value={emailLogin} onChange={e => setEmailLogin(e.target.value)} />
                                    <Input placeholder="Senha" type="password" value={passwordLogin} onChange={e => setPasswordLogin(e.target.value)} />
                                    <Button loading={isValidatingLogin} text={"Entrar"} type="submit" />
                                </form>
                                <p>Não tem uma conta? <button onClick={() => setIsOpen(true)} type="submit">Cadastre-se</button></p>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    )
}

export default Home;